import { SVGProps } from 'react';

export const YellowWarningIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.058 8.27789L43.376 35.0859C45.156 38.2019 42.906 42.0799 39.318 42.0799H8.68201C5.09201 42.0799 2.84201 38.2019 4.62401 35.0859L19.942 8.27789C21.736 5.13589 26.264 5.13589 28.058 8.27789Z"
        fill="#FFC96C"
        stroke="#FFC96C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.998 34.5C23.722 34.5 23.498 34.724 23.5 35C23.5 35.276 23.724 35.5 24 35.5C24.276 35.5 24.5 35.276 24.5 35C24.5 34.724 24.276 34.5 23.998 34.5"
        stroke="#63666A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24 28V18" stroke="#63666A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};